module.exports = __webpack_public_path__ + "media/images/university_logos/Cardiff-University-fdd4a9ff4c682881ba38553a6354def4.svg";